import { OrderCancelReason, TableVoidReason } from '@pedix-workspace/utils';
import { ProductStock, ProductStockSource } from './stock.types';

/**
 * Ref del movimiento derivada del `source` (no de un slot genérico): venta → `orderId`; conteo →
 * `inventoryCountId`. Como el `source` del write es siempre fresco, un `lastOrderId`/
 * `lastInventoryCountId` "stale" nunca se mis-atribuye a un movimiento de otro tipo (ver spec DR-3).
 */
export function getStockMovementRef(
  source: ProductStockSource,
  node: Pick<
    ProductStock,
    | 'lastOrderId'
    | 'lastOrderSequenceId'
    | 'lastOrderCancelReason'
    | 'lastInventoryCountId'
    | 'lastInventoryCountSequenceId'
    | 'lastTableSessionId'
    | 'lastTableSessionTableName'
    | 'lastTableSessionReason'
    | 'lastEntryId'
    | 'lastEntryName'
  >,
): {
  orderId?: string;
  orderSequenceId?: number;
  orderCancelReason?: OrderCancelReason;
  inventoryCountId?: string;
  inventoryCountSequenceId?: number;
  tableSessionId?: string;
  tableSessionTableName?: string;
  tableSessionReason?: TableVoidReason;
  entryId?: string;
  entryName?: string;
} {
  if (source === 'sale' || source === 'sale-edit' || source === 'sale-cancel') {
    return node.lastOrderId
      ? {
          orderId: node.lastOrderId,
          ...(node.lastOrderSequenceId != null
            ? { orderSequenceId: node.lastOrderSequenceId }
            : {}),
          ...(source === 'sale-cancel' && node.lastOrderCancelReason
            ? { orderCancelReason: node.lastOrderCancelReason }
            : {}),
        }
      : {};
  }
  if (source === 'count') {
    return node.lastInventoryCountId
      ? {
          inventoryCountId: node.lastInventoryCountId,
          ...(node.lastInventoryCountSequenceId != null
            ? { inventoryCountSequenceId: node.lastInventoryCountSequenceId }
            : {}),
        }
      : {};
  }
  if (source === 'table-session' || source === 'table-session-cancel') {
    return node.lastTableSessionId
      ? {
          tableSessionId: node.lastTableSessionId,
          ...(node.lastTableSessionTableName != null
            ? { tableSessionTableName: node.lastTableSessionTableName }
            : {}),
          ...(source === 'table-session-cancel' && node.lastTableSessionReason
            ? { tableSessionReason: node.lastTableSessionReason }
            : {}),
        }
      : {};
  }
  if (source === 'entry') {
    return node.lastEntryId
      ? {
          entryId: node.lastEntryId,
          ...(node.lastEntryName != null ? { entryName: node.lastEntryName } : {}),
        }
      : {};
  }
  return {};
}
